import { createFileRoute, notFound } from "@tanstack/react-router";
import { gatedRobotsMeta } from "@/lib/seo-gating";
import { TopicSectionView } from "@/components/learn/topic/TopicSectionView";

export const Route = createFileRoute("/learn/$topic/$section/")({
  // Topic content is fetched when a Learn page opens, not on every visit.
  loader: async ({ params }) => {
    const [{ getTopic }, { findSection }] = await Promise.all([
      import("@/data/learn/topics"),
      import("@/data/learn/topic-types"),
    ]);
    const topic = getTopic(params.topic);
    const section = topic ? findSection(topic, params.section) : null;
    if (!topic || !section) throw notFound();
    return { topic, section };
  },
  head: ({ loaderData }) => {
    if (!loaderData) {
      return { meta: [{ title: "Not found — Recovery Trauma™" }, { name: "robots", content: "noindex" }] };
    }
    const { topic, section } = loaderData;
    const title = `${section.title} — ${topic.title} — Recovery Trauma™`;
    const url = `https://recoverytrauma.com/learn/${topic.slug}/${section.slug}`;
    return {
      meta: [
        { title },
        { name: "description", content: section.blurb },
        { property: "og:title", content: title },
        { property: "og:description", content: section.blurb },
        { property: "og:type", content: "website" },
        { property: "og:url", content: url },
        { name: "twitter:card", content: "summary_large_image" },
        ...gatedRobotsMeta(`/learn/${topic.slug}/${section.slug}`),
      ],
      links: [{ rel: "canonical", href: url }],
    };
  },
  component: SectionPage,
});

function SectionPage() {
  const { topic, section } = Route.useLoaderData();
  return <TopicSectionView topic={topic} section={section} />;
}
